export enum OperationType {
	Contains = 0,
	NotContains = 1,
	StartsWith = 2,
	EndsWith = 3,
	Equals = 4,
	NotEquals = 5,
	Or = 6,
	And = 7
}
